// extracted by mini-css-extract-plugin
export default {"shareLive":"ShareLive_shareLive__rLyW5","shareLiveIcon":"ShareLive_shareLiveIcon__8+py0"};